import React from "react";
import { getShortenedReviewerName } from "./CustomerReviewHelper";

interface Props {
  name: string;
  company: string;
  date: string;
}

const ReviewerDetails = ({ name, company, date }: Props) => {
  return (
    <>
      <p className="text-gray-800 text-sm font-bold mb-0">
        {getShortenedReviewerName(name ?? "")}{" "}
        {company.length > 0 && <span className="font-normal">from </span>}
        {company}
      </p>
      <p className="mb-0 pt-1 text-gray-700 text-sm leading-4 font-normal pb-4">
        Posted on {date}
      </p>
    </>
  );
};

export default ReviewerDetails;
